/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react'

import { deleteCommonMetadata } from '../../../../assets/ts/data/common-metadata'
import { convertDate } from '../../../../assets/ts/date-and-time/date-and-time'
import Alert from '../../../../components/alert/alert'
import Buttons from '../../../../components/buttons/buttons'
import PageOverlayBusy from '../../../../components/page-overlay/page-overlay-busy'
import useCommonMetadata from '../../../../hooks/use-common-metadata'
import { SettingsHeader } from '../../../../layouts/header/settings-header'
import { DELETE_MESSAGE } from '../../../../utils/constants/rhybus-config'
import AddEditView from './add-edit-view'

interface RankItems {
  ItemKey: string
  abbreviation: string
  archived: boolean
  assignedcomponent: string | undefined
  rank: string
  status: string
}
const Rank = (props: any) => {
  const { commonMetadata, commonMetadataIsLoading, fetchCommonMetdata } = useCommonMetadata({
    isArchivedFilter: null,
  })

  const [rankItems, setRankItems] = useState<RankItems[]>([])

  const [clickedItem, setClickedItem] = useState<boolean>(false)
  const [showAddPopup, setShowAddPopup] = useState(false)
  const [showEdit, setShowEdit] = useState(false)

  const [inEditMode, setInEditMode] = useState({
    rowKey: null,
    status: false,
  })
  const [allRanks, setAllRanks] = useState<string[]>([])

  const addEditValue = (showAddPopup: any) => {
    setShowAddPopup(showAddPopup)
  }

  /* Function call on edit */
  const onEdit = (item: any) => {
    setInEditMode({
      rowKey: item.ItemKey,
      status: true,
    })
    setShowEdit(!showEdit)
  }
  /* Function call on cancel */
  const onCancel = () => {
    setInEditMode({
      rowKey: null,
      status: false,
    })
    setShowEdit(!showEdit)
  }

  const onDelete = async (item: any) => {
    setClickedItem(item)
    setShowAddPopup(false)
    setInEditMode({
      rowKey: null,
      status: false,
    })
  }
  const onClickAlert = async (button: string, item: any) => {
    if (button === 'OK') {
      setClickedItem(false)
      await deleteCommonMetadata(item)
      await fetchCommonMetdata()
    } else {
      setClickedItem(false)
    }
  }

  useEffect(() => {
    const updatedRankItems: any = commonMetadata
      .filter((c) => c.MetadataType === 'Rank')
      .map((m) => {
        return {
          ItemKey: m.eKey,
          abbreviation: m.ShortName,
          archived: m.IsArchived,
          assignedComponentCode: m.ParentCode,
          assignedcomponent: m.ParentCode
            ? commonMetadata.find((s) => s.Code === m.ParentCode)?.MetadataValue
            : '',
          code: m.Code,
          eKey: m.eKey,
          eTag: m.eTag,
          modified: `${convertDate(m.ItemModified, 'date') ?? ''}`,
          rank: m.MetadataValue,
          status: m.AdditionalValue3,
        }
      })
    updatedRankItems.sort((a, b) => b.modified.localeCompare(a.modified))
    const allranks = updatedRankItems.map((rank) => rank.rank)
    setAllRanks(allranks)
    setRankItems(updatedRankItems)
  }, [commonMetadata])

  return (
    <div className='row m-0'>
      {clickedItem && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={DELETE_MESSAGE}
          onClick={(e) => onClickAlert(e, clickedItem)}
          yes='OK'
        />
      )}
      <SettingsHeader
        extras={
          <div className='d-flex align-items-center'>
            <div className='ms-2 ms-sm-auto my-sm-2'>
              <Buttons
                aria-label='ADD'
                className='btn-sm font-0 font-xl-13 btn-primary ms-auto whitetext text-nowrap border-radius poppins-bold settingsaddbtn'
                icon='icon-add me-xl-1 font-11'
                label='ADD'
                onClick={() => {
                  setShowAddPopup(!showAddPopup)
                }}
              />
            </div>
          </div>
        }
        name='Rank'
      />
      <div className='p-0 settings-main mt-2'>
        {showAddPopup && (
          <AddEditView
            allRanks={allRanks}
            cancel={() => onCancel()}
            editItems={null}
            fetchCommonMetdata={fetchCommonMetdata}
            filtersvalue={addEditValue}
            showAddPopup={showAddPopup}
            showEdit={showEdit}
            toggleView={() => {
              setShowAddPopup(!showAddPopup)
            }}
          />
        )}
        {rankItems.map((rank) => (
          <div
            className='d-flex flex-column shadow card poppins-medium mb-2 py-3 my-2 mx-2'
            key={rank.ItemKey}
          >
            <div className='d-flex px-2'>
              <div className='d-flex flex-column flex-md-row flex-wrap w-100'>
                <div aria-live='polite' className='d-flex flex-column col my-2' tabIndex={0}>
                  <div className='title-color35 poppins-semibold font-12'>Rank</div>
                  <div className='poppins-semibold font-12 title-color2'>{rank.rank}</div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div
                  aria-live='polite'
                  className='d-flex flex-column min-w-100 w-100 max-w-100 my-2'
                  tabIndex={0}
                >
                  <div className='title-color35 poppins-semibold font-12'>Abbreviation</div>
                  <div className='poppins-semibold font-12 title-color2'>{rank.abbreviation}</div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div
                  aria-live='polite'
                  className='d-flex flex-column min-w-150 w-100 max-w-150 my-2'
                  tabIndex={0}
                >
                  <div className='title-color35 poppins-semibold font-12'>Assigned Component</div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {rank.assignedcomponent}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div
                  aria-live='polite'
                  className='d-flex flex-column min-w-100 w-100 max-w-100 my-2'
                  tabIndex={0}
                >
                  <div className='title-color35 poppins-semibold font-12'>Status</div>
                  <div className='poppins-semibold font-12 title-color2'>{rank.status}</div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block my-1'></div>
                <div
                  aria-live='polite'
                  className='d-flex flex-column min-w-100 w-100 max-w-80 my-2'
                  tabIndex={0}
                >
                  <div className='title-color35 poppins-semibold font-12'>Is Archived</div>
                  <div className='poppins-semibold font-12 title-color2'>
                    {rank.archived ? 'Yes' : 'No'}
                  </div>
                </div>
                <div className='dividerdashed vertical mx-2 mx-lg-3 d-none d-md-block'></div>
              </div>
              <div className='d-flex align-items-center'>
                <div className='d-flex gap-1 settings-actionbtns mx-2 mx-xxl-3'>
                  <Buttons
                    aria-label='Edit'
                    className={
                      inEditMode.status && inEditMode.rowKey === rank.ItemKey
                        ? 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto bgcolor-primary whitetext text-nowrap sourcesansprosemibold active'
                        : 'btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold'
                    }
                    icon='icon-pencil me-xl-1 font-10'
                    label='Edit'
                    onClick={() => onEdit(rank)}
                  />
                  <Buttons
                    aria-label='Delete'
                    className='btn-border btn-sm font-0 font-xl-14 btn-border-radius3 ms-auto color-primary text-nowrap sourcesansprosemibold'
                    icon='icon-trashbin me-xl-1 font-10'
                    label='Delete'
                    onClick={() => onDelete(rank)}
                  />
                </div>
              </div>
            </div>
            {inEditMode.status && inEditMode.rowKey === rank.ItemKey ? (
              <AddEditView
                allRanks={allRanks}
                cancel={() => onCancel()}
                editItems={rank}
                fetchCommonMetdata={fetchCommonMetdata}
                filtersvalue={addEditValue}
                showAddPopup={showAddPopup}
                showEdit={showEdit}
                toggleView={() => setClickedItem(false)}
              />
            ) : (
              ''
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
export default Rank
